import vm from "../main.js";
import StoreUtils from "./StoreUtils";
import {
  ErrorType,
} from "./ChatUtils";

class LazadaUtils {
  constructor() {
    this.attempt = 0;
    this.seller_appKey = '4272';
    this.chat_appKey = '24813843';

    this.instance = null;
  }

  /**
   * 单例构造方法，构造一个广为人知的接口，供用户对该类进行实例化
   * @returns {RequestUtils}
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new LazadaUtils();
    }
    return this.instance;
  }

  setLocalStronge (name, value)
  {
      localStorage.setItem(name, value);
      return true;
  }

  getLocalStronge (name)
  {
      return localStorage.getItem(name);
  }

  setCookie (name,value)
  {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
  }

  getCookie (cookieName){  
    var cookieValue="";  
    if (document.cookie && document.cookie != '') {   
        var cookies = document.cookie.split(';');  
        for (var i = 0; i < cookies.length; i++) {   
             var cookie = cookies[i];  
             if (cookie.substring(0, cookieName.length + 2).trim() == cookieName.trim() + "=") {  
                   cookieValue = cookie.substring(cookieName.length + 2, cookie.length);   
                   break;  
             }  
         }  
    }   
    return cookieValue;  
  }

  buildSign (storeId, sign_data, appKey) {
     let j = function(a) {
         function b(a, b) {
             return a << b | a >>> 32 - b
         }
         function c(a, b) {
             var e = 2147483648 & a
               , f = 2147483648 & b
               , c = 1073741824 & a
               , d = 1073741824 & b
               , g = (1073741823 & a) + (1073741823 & b);
             return c & d ? 2147483648 ^ g ^ e ^ f : c | d ? 1073741824 & g ? 3221225472 ^ g ^ e ^ f : 1073741824 ^ g ^ e ^ f : g ^ e ^ f
         }
         function h(a, e, f, g, h, i, j) {
             return a = c(a, c(c(function(a, b, c) {
                 return a & b | ~a & c
             }(e, f, g), h), j)),
             c(b(a, i), e)
         }
         function i(a, d, f, g, h, i, j) {
             return a = c(a, c(c(function(a, b, c) {
                 return a & c | b & ~c
             }(d, f, g), h), j)),
             c(b(a, i), d)
         }
         function j(a, d, e, g, h, i, j) {
             return a = c(a, c(c(d ^ e ^ g, h), j)),
             c(b(a, i), d)
         }
         function k(a, d, e, f, h, i, j) {
             return a = c(a, c(c(e ^ (d | ~f), h), j)),
             c(b(a, i), d)
         }
         function m(a) {
             for (var d = "", e = "", c = 0; c <= 3; c++)
                 d += (e = "0" + (a >>> 8 * c & 255).toString(16)).substr(e.length - 2, 2);
             return d
         }
         for (var p, q, r, s, x = function(a) {
             for (var b, c = a.length, d = c + 8, f = 16 * (1 + (d - d % 64) / 64), g = new Array(f - 1), h = 0, i = 0; i < c; )
                 h = i % 4 * 8,
                 g[b = (i - i % 4) / 4] = g[b] | a.charCodeAt(i) << h,
                 i++;
             return h = i % 4 * 8,
             g[b = (i - i % 4) / 4] = g[b] | 128 << h,
             g[f - 2] = c << 3,
             g[f - 1] = c >>> 29,
             g
         }(a = function(a) {
             a = a.replace(/\r\n/g, "\n");
             for (var b = "", c = 0; c < a.length; c++) {
                 var d = a.charCodeAt(c);
                 d < 128 ? b += String.fromCharCode(d) : (127 < d && d < 2048 ? b += String.fromCharCode(d >> 6 | 192) : (b += String.fromCharCode(d >> 12 | 224),
                 b += String.fromCharCode(d >> 6 & 63 | 128)),
                 b += String.fromCharCode(63 & d | 128))
             }
             return b
         }(a)), t = 1732584193, u = 4023233417, v = 2562383102, w = 271733878, o = 0; o < x.length; o += 16)
             t = h(p = t, q = u, r = v, s = w, x[o + 0], 7, 3614090360),
             w = h(w, t, u, v, x[o + 1], 12, 3905402710),
             v = h(v, w, t, u, x[o + 2], 17, 606105819),
             u = h(u, v, w, t, x[o + 3], 22, 3250441966),
             t = h(t, u, v, w, x[o + 4], 7, 4118548399),
             w = h(w, t, u, v, x[o + 5], 12, 1200080426),
             v = h(v, w, t, u, x[o + 6], 17, 2821735955),
             u = h(u, v, w, t, x[o + 7], 22, 4249261313),
             t = h(t, u, v, w, x[o + 8], 7, 1770035416),
             w = h(w, t, u, v, x[o + 9], 12, 2336552879),
             v = h(v, w, t, u, x[o + 10], 17, 4294925233),
             u = h(u, v, w, t, x[o + 11], 22, 2304563134),
             t = h(t, u, v, w, x[o + 12], 7, 1804603682),
             w = h(w, t, u, v, x[o + 13], 12, 4254626195),
             v = h(v, w, t, u, x[o + 14], 17, 2792965006),
             t = i(t, u = h(u, v, w, t, x[o + 15], 22, 1236535329), v, w, x[o + 1], 5, 4129170786),
             w = i(w, t, u, v, x[o + 6], 9, 3225465664),
             v = i(v, w, t, u, x[o + 11], 14, 643717713),
             u = i(u, v, w, t, x[o + 0], 20, 3921069994),
             t = i(t, u, v, w, x[o + 5], 5, 3593408605),
             w = i(w, t, u, v, x[o + 10], 9, 38016083),
             v = i(v, w, t, u, x[o + 15], 14, 3634488961),
             u = i(u, v, w, t, x[o + 4], 20, 3889429448),
             t = i(t, u, v, w, x[o + 9], 5, 568446438),
             w = i(w, t, u, v, x[o + 14], 9, 3275163606),
             v = i(v, w, t, u, x[o + 3], 14, 4107603335),
             u = i(u, v, w, t, x[o + 8], 20, 1163531501),
             t = i(t, u, v, w, x[o + 13], 5, 2850285829),
             w = i(w, t, u, v, x[o + 2], 9, 4243563512),
             v = i(v, w, t, u, x[o + 7], 14, 1735328473),
             t = j(t, u = i(u, v, w, t, x[o + 12], 20, 2368359562), v, w, x[o + 5], 4, 4294588738),
             w = j(w, t, u, v, x[o + 8], 11, 2272392833),
             v = j(v, w, t, u, x[o + 11], 16, 1839030562),
             u = j(u, v, w, t, x[o + 14], 23, 4259657740),
             t = j(t, u, v, w, x[o + 1], 4, 2763975236),
             w = j(w, t, u, v, x[o + 4], 11, 1272893353),
             v = j(v, w, t, u, x[o + 7], 16, 4139469664),
             u = j(u, v, w, t, x[o + 10], 23, 3200236656),
             t = j(t, u, v, w, x[o + 13], 4, 681279174),
             w = j(w, t, u, v, x[o + 0], 11, 3936430074),
             v = j(v, w, t, u, x[o + 3], 16, 3572445317),
             u = j(u, v, w, t, x[o + 6], 23, 76029189),
             t = j(t, u, v, w, x[o + 9], 4, 3654602809),
             w = j(w, t, u, v, x[o + 12], 11, 3873151461),
             v = j(v, w, t, u, x[o + 15], 16, 530742520),
             t = k(t, u = j(u, v, w, t, x[o + 2], 23, 3299628645), v, w, x[o + 0], 6, 4096336452),
             w = k(w, t, u, v, x[o + 7], 10, 1126891415),
             v = k(v, w, t, u, x[o + 14], 15, 2878612391),
             u = k(u, v, w, t, x[o + 5], 21, 4237533241),
             t = k(t, u, v, w, x[o + 12], 6, 1700485571),
             w = k(w, t, u, v, x[o + 3], 10, 2399980690),
             v = k(v, w, t, u, x[o + 10], 15, 4293915773),
             u = k(u, v, w, t, x[o + 1], 21, 2240044497),
             t = k(t, u, v, w, x[o + 8], 6, 1873313359),
             w = k(w, t, u, v, x[o + 15], 10, 4264355552),
             v = k(v, w, t, u, x[o + 6], 15, 2734768916),
             u = k(u, v, w, t, x[o + 13], 21, 1309151649),
             t = k(t, u, v, w, x[o + 4], 6, 4149444226),
             w = k(w, t, u, v, x[o + 11], 10, 3174756917),
             v = k(v, w, t, u, x[o + 2], 15, 718787259),
             u = k(u, v, w, t, x[o + 9], 21, 3951481745),
             t = c(t, p),
             u = c(u, q),
             v = c(v, r),
             w = c(w, s);
         return (m(t) + m(u) + m(v) + m(w)).toLowerCase()
     }
     var store_m_h5_tk = 'store'+storeId+':_m_h5_tk';
     var store_m_h5_tk_val = this.getLocalStronge(store_m_h5_tk);
     let tkheader;
     if (store_m_h5_tk_val) {
       tkheader = store_m_h5_tk_val.split('_')[0];
     } else {
       tkheader = 'undefined';
     }
     // console.log(store_m_h5_tk);
     // console.log(tkheader);
     var data = sign_data;
     var i = (new Date).getTime();
     var val = tkheader+'&'+i+'&'+appKey+'&'+data;  
     // console.log(val);
     return {
       'sign': j(val),
       't': i,
       'sign_data': sign_data
     };
   }
  /**
   * 带token的请求
   * @param url 请求路径
   * @param options 请求参数
   * @returns {Promise<Response | never>}
   */
  request(url, options, opt) {

    let self = this;
    let token = StoreUtils.getToken();
    opt = opt || {};
    opt.attempt = opt.attempt ? opt.attempt : 1;

    let storeId = options.get('store_id');
    let sign_data = options.get('sign_data');
    let appKey = options.get('appkey') ? options.get('appkey') : this.chat_appKey;
    
    let _m_h5_tk = this.getLocalStronge('store'+storeId+':_m_h5_tk');
    let _m_h5_tk_enc = this.getLocalStronge('store'+storeId+':_m_h5_tk_enc');
    let paramsData = this.buildSign(storeId, sign_data, appKey);
    options.set('sign', paramsData.sign);
    options.set('t', paramsData.t);
    options.set('_m_h5_tk', _m_h5_tk);
    options.set('_m_h5_tk_enc', _m_h5_tk_enc);

    if (opt.loading) {
      vm.$Spin.show({
          render: (h) => {
              return h('div', [
                  h('Icon', {
                      'class': 'spin-icon-load',
                      props: {
                          type: 'ios-loading',
                          size: 18
                      }
                  }),
                  h('div', 'Loading')
              ])
          }
      });
    }
    return self
    .timeoutFetch(
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          token: token
        },
        body: options
      }),
      10000
    )
    .then(response => {
      vm.$Spin.hide();
      return response.json();
    })
    .then(response => {
      if (response.code == 1) {
        return response.data;
      } else if (response.code == 401) {
        location.href="/";
      } else {
         if (response.msg == 'FAIL_SYS_ILLEGAL_ACCESS') {
            for (let k in response.data) {
              self.setLocalStronge(k, response.data[k]);  
            }
            if (opt.attempt > 0) {            
              opt.attempt--;
              return self.request(url, options, opt);                    
            }
        } else {
          vm.$Message.error(response.msg);
          for (let k in response.data) {
            self.setLocalStronge(k, response.data[k]);  
          }
          return false;
        }
      }
    });

  }

  guid () {
      for (var lut = [], i = 0; i < 256; i++)
          lut[i] = (i < 16 ? "0" : "") + i.toString(16);

      var d0 = 4294967295 * Math.random() | 0
        , d1 = 4294967295 * Math.random() | 0
        , d2 = 4294967295 * Math.random() | 0
        , d3 = 4294967295 * Math.random() | 0;
      var $guid = lut[255 & d0] + lut[d0 >> 8 & 255] + lut[d0 >> 16 & 255] + lut[d0 >> 24 & 255] + "-" + lut[255 & d1] + lut[d1 >> 8 & 255] + "-" + lut[d1 >> 16 & 15 | 64] + lut[d1 >> 24 & 255] + "-" + lut[63 & d2 | 128] + lut[d2 >> 8 & 255] + "-" + lut[d2 >> 16 & 255] + lut[d2 >> 24 & 255] + lut[255 & d3] + lut[d3 >> 8 & 255] + lut[d3 >> 16 & 255] + lut[d3 >> 24 & 255]
      console.log($guid);
      return $guid;
  }

  timeoutFetch(fetchPromise, timeout) {
    let abortFn = null;

    //这是一个可以被reject的promise
    let abortPromise = new Promise(function(resolve, reject) {
      abortFn = function() {
        reject(ErrorType.TIMEOUT_ERROR);
      };
    });

    //这里使用Promise.race，以最快 resolve 或 reject 的结果来传入后续绑定的回调
    let abortAblePromise = Promise.race([fetchPromise, abortPromise]);

    setTimeout(function() {
      abortFn();
    }, timeout);

    return abortAblePromise;
  }

}

export default LazadaUtils.getInstance();
